import { Button, type ButtonProps } from '@/ui-components/atoms/Button/Button';
import { Dispatch, SetStateAction } from 'react';

interface ButtonToggleProps extends Partial<ButtonProps> {
    text?: React.JSX.Element;
}

export default function getButtonToggle(
    isEnabled: boolean,
    setIsEnabled: Dispatch<SetStateAction<boolean>>,
    ariaControlsId?: string,
): (props: ButtonToggleProps) => React.JSX.Element {
    const ButtonToggle = (props: ButtonToggleProps) => (
        <Button
            onClick={() => setIsEnabled(!isEnabled)}
            variant="tertiary"
            tertiaryNoPadding
            type="button"
            {...(!!ariaControlsId && isEnabled ? { ariaExpanded: true } : {})}
            ariaControls={ariaControlsId}
            {...props}
        />
    );

    return ButtonToggle;
}
